var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"tw-bg-purple-900"},[_c('v-main',[_c('v-container',{staticClass:"tw-p-0",attrs:{"fluid":""}},[_vm._t("default")],2),_vm._v(" "),_c('snack-bar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }